import detailMessage from './detailMessage';
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { confirmPasswordChange } from "./api";
import ConfirmShell from "./components/ConfirmShell";
import { useLang } from "./LangContext";

type Status = "loading" | "ok" | "error";

interface PageState {
  status: Status;
  message?: string;
}

export default function PasswordChangeConfirmPage() {
  const { t } = useLang();
  const { token } = useParams<{ token: string }>();
  const [state, setState] = useState<PageState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    confirmPasswordChange(token!)
      .then(() => {
        if (cancelled) return;
        setState({ status: "ok" });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const detail = detailMessage(err, t.somethingWentWrong);
        setState({ status: "error", message: detail });
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <ConfirmShell>
      {state.status === "loading" && (
        <>
          <div className="confirm-spinner" aria-hidden="true" />
          <h2>{t.activatingPassword}</h2>
        </>
      )}
      {state.status === "ok" && (
        <>
          <div className="confirm-status-icon ok" aria-hidden="true">✓</div>
          <h2>{t.passwordActivatedTitle}</h2>
          <p>{t.passwordUpdatedMessage}</p>
          <p className="close-tab-hint">
            <Link to="/">{t.backToLogin}</Link>
          </p>
        </>
      )}
      {state.status === "error" && (
        <>
          <div className="confirm-status-icon error" aria-hidden="true">!</div>
          <h2>{t.somethingWentWrong}</h2>
          <p>{state.message}</p>
          <p className="close-tab-hint">{t.closeTab}</p>
        </>
      )}
    </ConfirmShell>
  );
}
